// Generated by CoffeeScript 1.11.1
(function() {
  var Util;

  Util = require('../util');

  module.exports = {
    parseLegacyLayerName: function() {
      var len;
      len = Util.pad4(this.file.readByte());
      return this.legacyName = this.file.readString(len);
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer/name.js
// module id = 53
// module chunks = 0